<div class="d-flex align-items-center justify-content-between">
  <p class="fw-bold text-primary-color">{{ title }}</p>
  <i class="fi" [ngClass]="icon"></i>
</div>
<nz-divider class="m-0 p-0 divider-primary-color"></nz-divider>
